'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.signout =
  exports.accessDeniedMessage =
  exports.resetState =
  exports.obtainAccessTokenWithRefreshToken =
  exports.obtainAccessTokenWithCode =
  exports.verifyState =
  exports.setAccessToken =
  exports.startRefreshGrant =
  exports.startAuthorizeGrant =
  exports.initOauth =
  exports.unregisterAuthInterceptors =
  exports.registerAuthInterceptors =
  exports.init =
  exports.getStore =
  exports.routerAdapter =
    void 0;
const axios_1 = require('axios');
const reducers_1 = require('./reducers');
const actions_1 = require('./actions');
const jsonwebtoken = require('jsonwebtoken');
const crypto_js_1 = require('crypto-js');
const cryptoRandomString = require('crypto-random-string');
let tokenObtainer;
let axiosRequestInteceptor;
let axiosResponseInteceptor;
let _store;
let _routerAdapter;
const generateCodeChallenge = (code_verifier) => {
  return crypto_js_1.enc.Base64.stringify(crypto_js_1.SHA256(code_verifier))
    .replace(/[+]/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};
exports.routerAdapter = () => {
  return _routerAdapter;
};
exports.getStore = () => {
  return _store;
};
exports.init = async (store, routerAdapter) => {
  _store = store;
  _routerAdapter = routerAdapter;
  await store.dispatch(exports.registerAuthInterceptors());
  await store.dispatch(exports.initOauth());
};
exports.registerAuthInterceptors = () => async (dispatch, getState) => {
  axiosRequestInteceptor = axios_1.default.interceptors.request.use(
    (config) => {
      var _a, _b, _c;
      if (
        !config.headers.AUTHORIZATION &&
        config.url !== process.env.AUTH_SERVER_REFRESH_ENDPOINT &&
        ((_b =
          (_a = getState()) === null || _a === void 0 ? void 0 : _a.auth) ===
          null || _b === void 0
          ? void 0
          : _b.accessToken)
      ) {
        config.headers.AUTHORIZATION = `Bearer ${(_c = getState().auth) === null || _c === void 0 ? void 0 : _c.accessToken}`;
      }
      return config;
    },
    (error) => {
      // Do something with request error
      return Promise.reject(error);
    },
  );
  axiosResponseInteceptor = axios_1.default.interceptors.response.use(
    (response) => {
      // Return a successful response back to the calling service
      return response;
    },
    async (error) => {
      var _a, _b, _c, _d, _e, _f;
      if (!error) {
        throw new Error('UNauthorized');
      }

      // Return any error which is not due to authentication back to the calling service
      if (!error.response || error.response.status !== 401) {
        throw error;
      }
      // Logout user if token refresh didn't work or user is disabled
      // if (error.config.url == process.env.AUTH_SERVER_REFRESH_ENDPOINT || error.response.message == "Account is disabled.") {
      console.log(
        'unauthorized',
        error.config.url,
        process.env.AUTH_SERVER_REFRESH_ENDPOINT,
      );
      if (error.config.url === process.env.AUTH_SERVER_REFRESH_ENDPOINT) {
        return dispatch(exports.signout());
      }
      // check if we even could
      try {
        const config = error.config;
        if (
          ((_a = getState().auth) === null || _a === void 0
            ? void 0
            : _a.accessToken) &&
          error.config.headers.AUTHORIZATION !==
            `Bearer ${(_b = getState().auth) === null || _b === void 0 ? void 0 : _b.accessToken}`
        ) {
          if (
            config.url !== process.env.AUTH_SERVER_REFRESH_ENDPOINT &&
            ((_c = getState().auth) === null || _c === void 0
              ? void 0
              : _c.accessToken)
          ) {
            config.headers.AUTHORIZATION = `Bearer ${(_d = getState().auth) === null || _d === void 0 ? void 0 : _d.accessToken}`;
          }
          return axios_1.default.request(config);
        }
        if (!getState().auth.refreshToken) {
          throw error;
        }
        await dispatch(exports.obtainAccessTokenWithRefreshToken());
        if (
          config.url !== process.env.AUTH_SERVER_REFRESH_ENDPOINT &&
          ((_e = getState().auth) === null || _e === void 0
            ? void 0
            : _e.accessToken)
        ) {
          config.headers.AUTHORIZATION = `Bearer ${(_f = getState().auth) === null || _f === void 0 ? void 0 : _f.accessToken}`;
        }
        return axios_1.default.request(config);
      } catch (e) {
        throw e;
      }
    },
  );
};
exports.unregisterAuthInterceptors = () => async (dispatch, getState) => {
  if (axiosRequestInteceptor) {
    axios_1.default.interceptors.request.eject(axiosRequestInteceptor);
    axiosRequestInteceptor = undefined;
  }
  if (axiosResponseInteceptor) {
    axios_1.default.interceptors.response.eject(axiosResponseInteceptor);
    axiosResponseInteceptor = undefined;
  }
};
exports.initOauth = () => async (dispatch, getState) => {
  dispatch(actions_1.authInitialized(false));
  const rt = window.localStorage.getItem(reducers_1.AUTH_REFRESHTOKEN_KEY);
  if (rt) {
    await dispatch(actions_1.authRefreshtoken(rt));
  }
  const idToken = window.localStorage.getItem(reducers_1.AUTH_IDTOKEN_KEY);
  if (idToken) {
    await dispatch(actions_1.authIdToken(idToken));
  }
  const at = window.localStorage.getItem(reducers_1.AUTH_ACCESSTOKEN_KEY);
  if (at) {
    const success = await dispatch(exports.setAccessToken(at));
    const hasRefresh = window.localStorage.getItem(
      reducers_1.AUTH_REFRESHTOKEN_KEY,
    );
    if (!success) {
      await dispatch(actions_1.authAccesstoken(at, {}));
    }
    if (!success && !hasRefresh) {
      await dispatch(exports.signout());
    }
  }
  if (!getState().auth.accessToken) {
    if (getState().auth.refreshToken) {
      await dispatch(exports.startAuthorizeGrant());
      await dispatch(exports.obtainAccessTokenWithRefreshToken());
      dispatch(actions_1.authInitialized(true));
    } else {
      await dispatch(exports.startAuthorizeGrant());
      dispatch(actions_1.authInitialized(true));
    }
  } else {
    dispatch(actions_1.authInitialized(true));
  }
};
exports.startAuthorizeGrant = () => async (dispatch) => {
  const codeVerifier = cryptoRandomString({ length: 32, type: 'url-safe' });
  dispatch(
    actions_1.initAuthorizeGrant(
      cryptoRandomString({ length: 32, type: 'url-safe' }),
      codeVerifier,
      generateCodeChallenge(codeVerifier),
    ),
  );
  // SHA256(codeVerifier).toString()
};
exports.startRefreshGrant = () => async (dispatch) => {
  dispatch(
    actions_1.initRefreshGrant(
      cryptoRandomString({ length: 32, type: 'url-safe' }),
    ),
  );
};
exports.setAccessToken = (accessToken) => async (dispatch) => {
  try {
    if (!process.env.AUTH_PUBLIC_KEY) {
      throw new Error('Auth Public Key not found');
    }
    const decodedToken = jsonwebtoken.verify(
      accessToken,
      process.env.AUTH_PUBLIC_KEY,
      {
        algorithms: ['RS256'],
      },
    );
    await dispatch(actions_1.authAccesstoken(accessToken, decodedToken));
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};
exports.verifyState = (state) => async (dispatch, getState) => {
  return state && getState().auth.state === state;
};
exports.login = (state) => (dispatch, getState) => {
  if (!dispatch(exports.setAccessToken(state.accessToken))) {
    throw new Error('Access Token failed');
  }
  if (state.refreshToken) {
    dispatch(actions_1.authRefreshtoken(state.refreshToken));
  }
  if (state.idToken) {
    dispatch(actions_1.authIdToken(state.idToken));
  }

  return true;
};
exports.obtainAccessTokenWithCode = (code) => async (dispatch, getState) => {
  try {
    dispatch(actions_1.authBusy(true));
    if (!tokenObtainer) {
      tokenObtainer = new Promise(async (resolve, reject) => {
        let res = await axios_1.default.post(
          `${process.env.AUTH_SERVER_TOKEN_ENDPOINT}`,
          {
            client_id: getState().auth.clientId,
            code_verifier: getState().auth.codeVerifier,
            state: getState().auth.state,
            code,
          },
        );
        if (
          !res.data ||
          !res.data.state ||
          !dispatch(exports.verifyState(res.data.state))
        ) {
          throw new Error('State mismatch');
        }
        if (!res.data.access_token) {
          throw new Error('Access Token not found in result');
        }
        if (!dispatch(exports.setAccessToken(res.data.access_token))) {
          throw new Error('Access Token failed');
        }
        if (res.data.refresh_token) {
          dispatch(actions_1.authRefreshtoken(res.data.refresh_token));
        }
        if (res.data.id_token) {
          dispatch(actions_1.authIdToken(res.data.refresh_token));
        }
        resolve(res.data);
      });
    }
    await tokenObtainer;
    dispatch(actions_1.authBusy(false));
    if (getState().auth.busy === 0) {
      tokenObtainer = undefined;
    }
    return true;
  } catch (e) {
    dispatch(actions_1.authBusy(false));
    if (getState().auth.busy === 0) {
      tokenObtainer = undefined;
    }
    throw e;
  }
};
exports.obtainAccessTokenWithRefreshToken =
  () => async (dispatch, getState) => {
    try {
      dispatch(actions_1.authBusy(true));
      await dispatch(exports.startRefreshGrant());
      if (!tokenObtainer) {
        tokenObtainer = new Promise(async (resolve, reject) => {
          let res = await axios_1.default
            .post(`${process.env.AUTH_SERVER_REFRESH_ENDPOINT}`, {
              client_id: getState().auth.clientId,
              refresh_token: getState().auth.refreshToken,
            })
            .catch(async () => {
              await dispatch(exports.signout());
              return {
                data: {},
              };
            });
          if (!res.data.access_token) {
            throw new Error('Access Token bot found in result');
          }
          if (!dispatch(exports.setAccessToken(res.data.access_token))) {
            throw new Error('Access Token failed');
          }
          if (res.data.refresh_token) {
            dispatch(actions_1.authRefreshtoken(res.data.refresh_token));
          }
          if (res.data.id_token) {
            dispatch(actions_1.authIdToken(res.data.refresh_token));
          }
          resolve(res.data);
        });
      }
      await tokenObtainer;
      dispatch(actions_1.authBusy(false));
      await dispatch(actions_1.resetRefreshGrant());
      if (getState().auth.busy === 0) {
        tokenObtainer = undefined;
      }
      return true;
    } catch (e) {
      dispatch(actions_1.authBusy(false));
      await dispatch(actions_1.resetRefreshGrant());
      if (getState().auth.busy === 0) {
        tokenObtainer = undefined;
      }
      throw e;
    }
  };
exports.resetState = () => async (dispatch, getState) => {
  var _a;
  const subscribers = getState().auth.resetSubscribers
    ? [...getState().auth.resetSubscribers]
    : [];
  let err;
  (_a = getState().auth.resetSubscribers) === null || _a === void 0
    ? void 0
    : _a.map(async (el) => {
        try {
          await dispatch(el());
        } catch (e) {
          err = e;
        }
      });
  try {
    await dispatch(actions_1.authReset());
  } catch (e) {
    err = e;
  }
  if (subscribers) {
    dispatch(actions_1.authResetSubscribers(subscribers));
  }
  if (err) {
    throw err;
  }
};
exports.accessDeniedMessage = (msg, timeout) => async (dispatch, getState) => {
  if (timeout !== undefined) {
    dispatch(actions_1.authAccessDeniedMessageTimeout(timeout));
  }
  dispatch(actions_1.authAccessDeniedMessage(msg));
  if (msg !== '') {
    if (timeout !== undefined) {
      dispatch(
        actions_1.authAccessDeniedMessageTimeout(
          getState().auth.defaultAccessDeniedMessageTimeout,
        ),
      );
    }
    dispatch(actions_1.authAccessDeniedMessage(''));
  }
};
exports.signout =
  (route = true) =>
  async (dispatch, getState) => {
    if (route === true) {
      route = getState().auth.signOutRoute;
    }
    await axios_1.default.post('/api/auth/logout').finally(async () => {
      await dispatch(exports.resetState());
      await dispatch(actions_1.authSignout());
      await dispatch(exports.initOauth());
      window.location.href = '/';
    });
    if (route) {
      exports.routerAdapter().go(route);
    }
  };
